export default "__VITE_ASSET__Bd0Gm0wq__"